import React from 'react';

const TaskFilterToolBar = ({ activeFilter, handleFilterChange, isDropdownOpen, setIsDropdownOpen }) => {
    const getPriorityLabel = () => {
        if (activeFilter === 'high') return 'Priority: High';
        if (activeFilter === 'medium') return 'Priority: Medium';
        if (activeFilter === 'low') return 'Priority: Low';
        return 'Filter Priority';
    };

    return (
        <div className='d-flex mb-2 gap-2'>
            <button 
                className={`btn btn-sm ${activeFilter === 'all' ? 'btn-primary' : 'btn-outline-primary'}`}
                onClick={() => handleFilterChange('all')}
            >
                All Tasks
            </button>
            
            <button 
                className={`btn btn-sm ${activeFilter === 'mine' ? 'btn-primary' : 'btn-outline-primary'}`}
                onClick={() => handleFilterChange('mine')}
            >
                My Tasks
            </button>

            <button 
                className={`btn btn-sm ${activeFilter === 'my-assigned' ? 'btn-primary' : 'btn-outline-primary'}`}
                onClick={() => handleFilterChange('my-assigned')}
            >
                Assigned To Me
            </button>

            <div className="dropdown">
                <button 
                    className={`btn btn-sm dropdown-toggle ${['high', 'medium', 'low'].includes(activeFilter) ? 'btn-primary' : 'btn-outline-primary'}`} 
                    type="button"
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                    {getPriorityLabel()}
                </button>
                
                <ul className={`dropdown-menu ${isDropdownOpen ? 'show' : ''}`} 
                    style={{ display: isDropdownOpen ? 'block' : 'none', position: 'absolute' }}>
                    <li><button className="dropdown-item" onClick={() => handleFilterChange('high')}>High</button></li>
                    <li><button className="dropdown-item" onClick={() => handleFilterChange('medium')}>Medium</button></li>
                    <li><button className="dropdown-item" onClick={() => handleFilterChange('low')}>Low</button></li>
                    <li><hr className="dropdown-divider" /></li>
                    <li><button className="dropdown-item" onClick={() => handleFilterChange('all')}>Reset</button></li>
                </ul>
            </div>
        </div>
    );
};

export default TaskFilterToolBar;